// @TODO
export default {
  change: 'campaign.change_campaign',
  manage: 'campaign.manage_campaign',
};
